import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss']
})
export class ResetPasswordEmailComponent implements OnInit {

  sectionTitle = 'Reset Your Password'
  SIResetPassword = {
    label: 'Email address'
  }

  constructor() { }

  ngOnInit() {
  }

}
